import type {NotificationEvent} from '../../../../api/event';
import type {EventContextsMap} from './types';

export const getEventContexts = (event: NotificationEvent) => {
  const eventContextsMap: EventContextsMap = {};

  event.context_ids.forEach((id, i) => {
    const context = event.contexts[i];

    const key = id.split(':')[0]!;

    if (event.actor) {
      eventContextsMap.actor = event.actor;
    } else {
      eventContextsMap.actor = {
        coach_title: 'Coach not found',
        name: 'User not found',
      };
    }

    if (context) {
      eventContextsMap[key] = context;
    } else {
      switch (key) {
        case 'certificate': {
          eventContextsMap.certificate = {
            title: 'Certificate not found',
          };
          break;
        }
        case 'conference': {
          eventContextsMap.conference = {
            title: 'Conference not found',
          };
          break;
        }
        case 'goal': {
          eventContextsMap.goal = {
            title: 'Goal not found',
          };
          break;
        }
        case 'invite': {
          eventContextsMap.invite = {
            coach: {
              coach_title: 'Coach not found',
            },
            message: 'Invite not found',
            user_questionnaire: {
              title: 'Questionnaire not found',
            },
          };
          break;
        }
        case 'program': {
          eventContextsMap.program = {
            title: 'Program not found',
          };
          break;
        }
        case 'subgoal': {
          eventContextsMap.subgoal = {
            title: 'Short-term goal not found',
          };
          break;
        }
        case 'task': {
          eventContextsMap.task = {
            title: 'Task not found',
          };
          break;
        }
        case 'user': {
          eventContextsMap.user = {
            coach_title: 'Coach not found',
            name: 'User not found',
          };
          break;
        }
        case 'user_questionnaire': {
          eventContextsMap.user_questionnaire = {
            title: 'Questionnaire not found',
          };
          break;
        }
        default:
          break;
      }
    }
  });

  return eventContextsMap;
};
